import { render } from "./Family_A.vue?vue&type=template&id=59c9a400&scoped=true"
import script from "./Family_A.vue?vue&type=script&lang=js"
export * from "./Family_A.vue?vue&type=script&lang=js"

import "./Family_A.vue?vue&type=style&index=0&id=59c9a400&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c9a400"]])

export default __exports__